module.exports = {
      id: "icon-google-play-usage",
      viewBox: "0 0 12.598 13.975",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-google-play",
      toString: function () {
        return this.url;
      }
    }